<p-sidebar
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [showCloseIcon]="false"
  [dismissible]="true"
  [baseZIndex]="20000"
  appendTo="body"
  styleClass="matrix-sidebar-visor-adjunto"
  (onHide)="cerrar()"
>
  <!-- ===================== HEADER ===================== -->
  <div class="visor-sidebar-header">
    <div class="visor-header-titulos">
      <span class="visor-titulo-principal">{{ 'MATRIX.LBL_VISUALIZACION' | translate }}</span>
    </div>
    <div class="visor-header-acciones">
      <div class="visor-zoom-control">
        <span class="zoom-label">{{ 'MATRIXADJUNTOSMODAL.LBL_ZOOM' | translate }}</span>
        <p-dropdown
          [options]="opcionesZoom"
          [(ngModel)]="zoom"
          optionLabel="label"
          optionValue="value"
          styleClass="zoom-dropdown"
        ></p-dropdown>
      </div>
      <button type="button" class="btn-cerrar-visor" (click)="cerrar()" title="{{ 'LBL_CERRAR' | translate }}">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <!-- ===================== BANNER / CARD DEL DOCUMENTO ===================== -->
  <div class="visor-doc-card">
    <div class="doc-card-left">
      <div class="doc-icono">
        <i class="pi pi-file"></i>
      </div>
      <div class="doc-info">
        <span class="doc-nombre" [title]="nombreArchivo || adjunto?.nombreRespaldo || adjunto?.nombre">
          {{ nombreArchivo || adjunto?.nombreRespaldo || adjunto?.nombre || 'documento' }}
        </span>
        <span class="doc-subtitulo">
          {{ subtituloCarga }}
        </span>
      </div>
    </div>

    <div class="doc-card-right">
      <span class="badge-calificacion" [ngClass]="estadoCalificacionClase">
        {{ estadoCalificacionTexto }}
      </span>

      <button
        type="button"
        class="btn-descargar-adjunto"
        (click)="descargar()"
        [disabled]="loadingFile || !archivoBlob"
      >
        <i class="pi pi-download"></i>
        <span>{{ 'MATRIXADJUNTOSMODAL.BTN_DESCARGAR' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- ===================== VISOR CENTRAL ===================== -->
  <div class="visor-sidebar-body">
    <div *ngIf="loadingFile" class="visor-loading">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
      <span>{{ 'LBL_CARGANDO' | translate }}</span>
    </div>

    <div
      *ngIf="!loadingFile && fileUrl"
      class="visor-documento-contenedor"
      [style.transform]="'scale(' + (zoom / 100) + ')'"
      [style.transformOrigin]="'top center'"
    >
      <iframe
        *ngIf="esPdf"
        [src]="fileUrl"
        class="visor-iframe"
        title="Documento PDF"
      ></iframe>

      <img
        *ngIf="!esPdf"
        [src]="fileUrl"
        class="visor-imagen"
        alt="Documento adjunto"
      />
    </div>

    <div *ngIf="!loadingFile && !fileUrl" class="visor-sin-archivo">
      <span>{{ 'MSG_NOHAYREGISTROS' | translate }}</span>
    </div>
  </div>

  <!-- ===================== FOOTER CON ACCIONES APROBAR / RECHAZAR ===================== -->
  <div class="visor-sidebar-footer">
    <button
      type="button"
      class="btn-calificar-rechazar"
      [disabled]="guardandoCalificacion || loadingFile"
      (click)="calificar(false)"
    >
      <i class="pi pi-times-circle"></i>
      <span>{{ 'MATRIXADJUNTOSMODAL.BTN_RECHAZAR' | translate }}</span>
    </button>

    <button
      type="button"
      class="btn-calificar-aprobar"
      [disabled]="guardandoCalificacion || loadingFile"
      (click)="calificar(true)"
    >
      <i class="fa fa-refresh fa-spin mr-1" *ngIf="guardandoCalificacion"></i>
      <i class="pi pi-check-circle" *ngIf="!guardandoCalificacion"></i>
      <span>{{ 'MATRIXADJUNTOSMODAL.BTN_APROBAR' | translate }}</span>
    </button>
  </div>
</p-sidebar>
